import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import Global from '../components/global'
import ContactBlock from '../components/contactblock'

//import Header from './header'

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        {/* <Header siteTitle={data.site.siteMetadata.title} /> */}
        <Global/>
        <div className='section-wrapper'>
        {children}
        <ContactBlock />
        </div>
      </>
    )}
  /> 
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
